export default{
    title:'酷骑',
    smallTitle:'智能骑行APP',
    describe:'开启你的骑行新体验',
    content:'智能、便携、有趣，重新定义每一次骑行',
    iosDownload:'App Store下载',
    AndroidDownload:'Android下载',
    twoTitle:' 酷骑优势',
    twoDescribe:'蓝牙解锁',
    twoDescribeTwo:'智能路线规划',
    twoDescribeThree:'健康数据显示',
    twoDescribeFour:'社交互动',
    threeTitle:'酷骑为运动而生',
    threeDescribe:'简单三步，绑定爱车，畅享骑行乐趣',
    fourTitle:'开启骑行新体验',
    fourDescribe:'简单三步，绑定爱车，畅享骑行乐趣',
    fourContentFirstTitle:'下载APP',
    fourContentFirstContent:'酷骑APP，你的随行管家，',
    fourContentFirstContentTwo:'一键解锁骑行新体验',
    fourContentSecondTitle:'绑定配对',
    fourContentSecondContent:'只需简单几步，在APP中绑定与',
    fourContentSecondContentTwo:'车辆配套的智能仪表，就能将爱',
    fourContentSecondContentThree:'车纳入掌控范围',
    fourContentThirdTitle:'开启智慧骑行',
    fourContentThirdContent:'远程查看车辆状态（电量情况、',
    fourContentThirdContentTwo:'停放位置等）远程解锁、上锁，',
    fourContentThirdContentThree:'尽享智能便携的骑行生活',
    footTitle:'开启你的骑行新体验',
    footCompanyName:'Copyright © 2021 深圳市汇联时代科技有限公司',
    footRecordNumber:'粤ICP备18045622号'
}